<template>
	<div v-if="newsItems.length">
		<transition-group 
			name="feed-transition"
			tag="div"
			class="mg-grid"
			enter-active-class="animated fadeInUp" 
			leave-active-class="animated fadeOut">
			<card v-for="(item, index) in newsItems" :key="index" :post="item"></card>
		</transition-group>
		<div class="p-4 py-10 text-center antialiased" v-if="moreToLoad">
            <button @click="loadMoreArticles" class="mg-button mg-button--accent px-6 uppercase">Load More</button>
        </div>
	</div>
    <div v-else class="mg-banded-accent-2-lightest mg-color-accent-2 py-2 px-4 rounded-lg text-center">
        <div v-if="totalItemsFound == null">
            Loading news...
        </div>
        <div v-else>
            Nothing found.
        </div>
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import Card from "@/vue-components/card";

export default {
    name: "card-feed",
    components: {
        card: Card
    },
    computed: {
        ...mapState(["newsItems", "totalItemsFound"]),
        moreToLoad() {
            if (this.totalItemsFound === null) {
                return false;
            } else {
                return !(
                    parseInt(this.totalItemsFound) === this.newsItems.length
                );
            }
        }
    },
    methods: {
        ...mapActions(["getNewsroomFeed"]),
        loadMoreArticles() {
            //Check for prop, then if it's the desired post type, use the endpoint.
            this.getNewsroomFeed(true);
        }
    },
    created() {
        //Check for prop, then if it's the desired post type, use the endpoint.
        this.getNewsroomFeed();
    }
};
</script>



// WEBPACK FOOTER //
// src/js/vue-components/card-feed.vue